import * as React from 'react';

import SelectStorySnippetsList from '../select-story-snippets-list/SelectStorySnippetsList';

import { __t, applyTranslations } from 'utils/language';
import { getTotalCountInGroups } from 'modules/select-story-snippets/utils/general';

import './select-story-snippets-grouped-view.scss';

applyTranslations(require('./select-story-snippets-grouped-view.i18n.json'));

import { GroupedByDate, StorySnippet } from 'modules/select-story-snippets/types';

interface Props {
  snippets: GroupedByDate<StorySnippet>,
  selectedSnippets: Array<string>,
  previewSnippetCode: null | string,
  onToggleSnippet: (code: string) => void,
  onRequestSnippetPreview: (code: string) => void
}

const SelectStorySnippetsGroupedView = ({
  snippets,
  selectedSnippets,
  previewSnippetCode,
  onToggleSnippet,
  onRequestSnippetPreview
}: Props): JSX.Element => {
  const count = getTotalCountInGroups(snippets);
  const scrollRef = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (!scrollRef.current) {
      return;
    }

    scrollRef.current.scrollIntoView();
  }, [previewSnippetCode]);

  if (count === 0) {
    return (
      <div className="select-story-snippets-grouped-view">
        <span>{__t('select_story_snippets_grouped_view.empty')}</span>
      </div>
    );
  }

  return (
    <React.Fragment>
      {Object.keys(snippets).map(key => {
        if (snippets[key].length === 0) {
          return null;
        }

        return (
          <div
            key={key}
            className="select-story-snippets-grouped-view__block"
            ref={snippets[key].find(s => s.code === previewSnippetCode) ? scrollRef : undefined}
          >
            <span className="select-story-snippets-grouped-view__header">
              {__t(`select_story_snippets_grouped_view.headers.${key}`)}
            </span>
            <SelectStorySnippetsList
              snippets={snippets[key]}
              selectedSnippets={selectedSnippets}
              previewSnippetCode={previewSnippetCode}
              onChange={onToggleSnippet}
              onRequestPreview={onRequestSnippetPreview}
            />
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default SelectStorySnippetsGroupedView;
